import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import ConfidentialityLock from "candidate/ConfidentialityLock";

export default function CheckInHeader(
    { isKiosk, checkinType, isAnonymous, questionCount, current, checkinRemoveConfidentiality },
    { t: _ },
) {
    const legalText = useSelector((state) => state.company?.settings?.retain?.kiosk?.legal_text);
    const companyName = useSelector((state) => state.company?.name ?? "");

    return (
        <header className="check-in__header">
            <div className="check-in__header-left">
                {!checkinRemoveConfidentiality && (
                    <ConfidentialityLock
                        legalText={legalText}
                        isAnonymous={isAnonymous}
                        isKiosk={isKiosk}
                        checkinType={checkinType}
                        companyName={companyName}
                    />
                )}
            </div>
            {!legalText && questionCount > 1 && (
                <div className="check-in__header-right">
                    {current} {_("of")} {questionCount}
                </div>
            )}
        </header>
    );
}

CheckInHeader.contextTypes = {
    t: PropTypes.func,
};

CheckInHeader.propTypes = {
    isKiosk: PropTypes.bool,
    checkinType: PropTypes.number,
    isAnonymous: PropTypes.bool,
    questionCount: PropTypes.number,
    current: PropTypes.number,
    checkinRemoveConfidentiality: PropTypes.bool,
};

CheckInHeader.defaultProps = {
    isKiosk: false,
    checkinType: "",
    isAnonymous: false,
    questionCount: 0,
    current: 0,
    checkinRemoveConfidentiality: false,
};
